module.exports = __webpack_public_path__ + "static/media/monitor_inventory.df49d580.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/monitor_inventory.svg
// module id = 404
// module chunks = 0